import { stringify } from 'query-string';
import { API_URL } from '../../../app-config/constants';
import type {
    ResponseGrouping,
    SurveyResponseAggregation,
    SurveyResponseAggregationV2,
} from '../../../types/SurveyResponses';
import { get } from '../request';

const ENTRY = `${API_URL}/surveys`;

export type AggregationOptions = {
    grouping?: ResponseGrouping;
    reviewCycleId?: string;
    ratingId?: string;
    filters?: string[];
    /** ISO 8601 string */
    from?: string;
    /** ISO 8601 string */
    to?: string;
};

getAll.operation = 'READ';
getAll.idFrom = 'ARGS';
export function getAll(surveyId: string, options: AggregationOptions): Promise<SurveyResponseAggregation> {
    const urlParams = stringify(options);
    return get(`${ENTRY}/${surveyId}/responses` + (urlParams ? `?${urlParams}` : ''));
}

export type AggregationOptionsV2 = {
    /** ISO 8601 string */
    from?: string;
    /** ISO 8601 string */
    to?: string;
    filters?: string[];
};

getAllV2.operation = 'READ';
getAllV2.idFrom = 'ARGS';
export function getAllV2(surveyId: string, options: AggregationOptionsV2): Promise<SurveyResponseAggregationV2> {
    const urlParams = stringify(options);
    return get(`${ENTRY}/${surveyId}/responses-v2` + (urlParams ? `?${urlParams}` : ''));
}
